module.exports = __webpack_public_path__ + "media/svg-new/icon-chev-right-21e71b70.svg";